'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs-2/~/chart.js/src/charts/Chart.Doughnut.js
// module id = 590
// module chunks = 0